import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchQuotations(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/quotations', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/quotations/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/quotations', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/quotations/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidQuotation(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/quotations/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchQuotationTemplates(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/quotation_templates', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchQuotationTemplate(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/quotation_templates/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createQuotationTemplate(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/quotation_templates', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateQuotationTemplate(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/quotation_templates/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidQuotationTemplate(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/quotation_templates/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    copyQuotationTemplate(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/quotation_templates/copy', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}